// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout, { BulletList, InfoCallout, Section } from "../components/LegalPageLayout";

export default function TermsOfService() {
  return (
    <LegalPageLayout
      title="Terms of Service"
      subtitle="Cardex is a local, in-person trading coordination platform for adult collectors."
      updated="February 7, 2026"
    >
      <Section title="Phase 1 Notice">
        <InfoCallout title="Phase 1 Scope">
          These Terms reflect Cardex Phase 1 functionality. Cardex is a local, in-person trading 
          coordination platform for adults (18+). We do not process payments, handle shipping, 
          or provide transaction guarantees. All trading occurs directly between users.
        </InfoCallout>
      </Section>

      <Section title="1. Agreement to Terms">
        <p>
          By accessing and using Cardex ("the Platform"), you agree to be bound by these Terms of Service
          and all applicable laws and regulations. If you do not agree with any of these terms, you are
          prohibited from using or accessing this site.
        </p>
      </Section>

      <Section title="2. Platform Description">
        <p>
          Cardex is a <strong>trading coordination platform</strong> that helps adult collectors (18+) 
          connect for local, in-person trades and meetups. We facilitate discovery, messaging, and 
          moderation only.
        </p>
        <p><strong>Cardex does NOT:</strong></p>
        <BulletList
          items={[
            "Process payments or handle money",
            "Arrange or facilitate shipping",
            "Provide escrow services or transaction guarantees",
            "Process refunds or chargebacks",
            "Act as a buyer, seller, or intermediary in trades",
            "Authenticate, grade, or verify cards"
          ]}
        />
        <p>
          All trades occur <strong>directly between users in person</strong>. We are not affiliated 
          with any trading card publisher; trademarks belong to their respective owners.
        </p>
      </Section>

      <Section title="3. Age Requirement (18+ Only)">
        <p>
          <strong>You must be at least 18 years old to use Cardex.</strong> By creating an account, you
          confirm that you are 18 years of age or older. Cardex is an adults-only platform designed for
          in-person meetups and trading coordination.
        </p>
        <p>
          Accounts belonging to minors will be immediately terminated upon discovery. We do not knowingly
          collect personal information from anyone under 18.
        </p>
      </Section>

      <Section title="4. User Accounts">
        <p>
          You must create an account to use certain features. <strong>In Phase 1, your Cardex account 
          is used solely for:</strong>
        </p>
        <BulletList
          items={[
            "Messaging other collectors",
            "Identity verification and profile creation",
            "Platform moderation and safety enforcement"
          ]}
        />
        <p>
          <strong>Cardex is not a buyer, seller, or intermediary.</strong> We do not facilitate 
          transactions, hold funds, or guarantee trades. Your account enables you to coordinate meetups 
          with other users; all trading happens directly between users in person.
        </p>
        <p>You are responsible for:</p>
        <BulletList
          items={[
            "Maintaining the confidentiality of your account credentials",
            "All activities that occur under your account",
            "Notifying us immediately of any unauthorized use",
            "Providing accurate and complete information"
          ]}
        />
      </Section>

      <Section title="5. User Conduct">
        <p>When using Cardex, you agree to:</p>
        <BulletList
          items={[
            "Treat other traders with respect",
            "Provide accurate information in your profile and trade posts",
            "Meet in public places for in-person trades",
            "Not share personal information (phone numbers, email, home address) in messages",
            "Report any suspicious activity or abuse"
          ]}
        />
      </Section>

      <Section title="6. Prohibited Activities">
        <p>You may not:</p>
        <BulletList
          items={[
            "Post counterfeit or stolen cards",
            "Harass, threaten, or defraud other users",
            "Use the platform for illegal activities",
            "Create multiple accounts to evade bans",
            "Spam or send unsolicited messages"
          ]}
        />
      </Section>

      <Section title="7. Intellectual Property">
        <p>
          Card names and trademarks are property of their respective publishers. See our
          {" "}
          <Link className="legal-link" to="/ip-disclaimer">
            IP & Trademark Disclaimer
          </Link>
          {" "}
          for full details.
        </p>
      </Section>

      <Section title="8. Limitation of Liability">
        <p>Cardex is a platform for coordinating in-person trades. We are not responsible for:</p>
        <BulletList
          items={[
            "The authenticity or condition of cards traded",
            "In-person meetups or interactions between users",
            "Lost, stolen, or damaged items",
            "Disputes between traders"
          ]}
        />
        <p>All trades occur at your own risk. Meet in public places and exercise caution.</p>
      </Section>

      <Section title="9. Account Termination">
        <p>
          We reserve the right to suspend or terminate accounts that violate these terms. You may
          request account deletion at any time from the Account menu.
        </p>
      </Section>

      <Section title="10. Changes to Terms">
        <p>
          We may update these terms periodically. Continued use of the platform after changes constitutes
          acceptance of the updated terms.
        </p>
      </Section>

      <Section title="11. Governing Law">
        <p>These terms are governed by the laws of the United States.</p>
      </Section>

      <Section title="12. Contact">
        <p>
          For questions about these terms, contact us at: <strong>legal@cardexhq.com</strong>
        </p>
      </Section>

      <p className="legal-footer-text">
        By using Cardex, you acknowledge that you have read, understood, and agree to these Terms of
        Service.
      </p>
    </LegalPageLayout>
  );
}
